import {
	COLUMN_ID_CHECKBOX,
	COLUMN_ID_EXPAND_BUTTON,
	EXPAND_CELL_PADDING,
} from '../../constants.tsx';
import type { Column } from '../../types.tsx';

export const getColumnsWithStickyOffsets = (columnConfig: Column[], stickyColumnIds: string[]) => {
	const stickyColumnsById: {
		[key: string]: Column;
	} = {};
	const orderedStickyColumns: Column[] = [];
	const nonStickyColumns: Column[] = [];

	columnConfig.forEach((column) => {
		const { id } = column;
		if (id === COLUMN_ID_CHECKBOX || id === COLUMN_ID_EXPAND_BUTTON) {
			orderedStickyColumns.push(column);
		} else if (stickyColumnIds?.includes(id)) {
			stickyColumnsById[id] = column;
		} else {
			nonStickyColumns.push(column);
		}
	});

	stickyColumnIds.forEach((columnId) => {
		if (stickyColumnsById[columnId]) {
			orderedStickyColumns.push(stickyColumnsById[columnId]);
		}
	});

	let cumulativeStickyOffset = 0;
	const processedStickyColumns = orderedStickyColumns.map((column) => {
		const { id, customWidth, defaultWidth } = column;
		const stickyOffsets = cumulativeStickyOffset;
		if (id === COLUMN_ID_EXPAND_BUTTON) {
			cumulativeStickyOffset += defaultWidth + EXPAND_CELL_PADDING;
		} else {
			cumulativeStickyOffset += customWidth ?? defaultWidth;
		}

		return {
			...column,
			isColumnSticky: true,
			stickyOffsets,
		};
	});
	return [...processedStickyColumns, ...nonStickyColumns];
};
